import React from 'react'
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {Mutation} from 'react-apollo'
import {toast} from 'react-toastify'

import ContactItem from "./ContactItem";
import removeProjectClientMutation from '../../queries/server/mutations/remove_project_client_mutation'
import editProjectLocalMutation from '../../queries/client_side/mutations/edit_project'

const ProjectClientListItem = ({project_id, client, onRemove}) => {

    const {client_id, name, client_contacts} = client

    return (
        <Mutation mutation={removeProjectClientMutation}>
            {(removeProjectClientMutationFunc, {loading}) => (
                <div className="d-flex flex-row align-items-start justify-content-between border-bottom mt-3">
                    <div className="d-flex flex-column justify-content-between">
                        <div className="d-flex flex-column align-items-start justify-content-start">
                            <h5>{name}</h5>
                        </div>

                        {client_contacts && <div className="d-flex flex-row align-items-start">
                            {
                                client_contacts.map(contact => <ContactItem {...contact}/>)
                            }

                        </div>}
                    </div>
                    <div className="d-flex flex-column justify-content-around align-self-stretch">
                        <Mutation mutation={editProjectLocalMutation}>
                            {(editProjectLocalMutationFunc) => (
                                <Button
                                    size="sm"
                                    color="danger"
                                    className="square-btn"
                                    onClick={() => {
                                        removeProjectClientMutationFunc({variables: {project_id, client_ids: [client_id]}})
                                            .then(({data}) => {
                                                editProjectLocalMutationFunc({variables: {data: data.removeProjectClients}})
                                                toast.success('Client Removed', {autoClose: 2000})
                                            })
                                            .catch(e => toast.error(e.message, {autoClose: false}))
                                    }}
                                    disabled={loading}
                                >
                                    <FontAwesomeIcon color="#fff" icon="trash-alt"/>
                                    {loading && 'Removing...'}
                                </Button>
                            )}
                        </Mutation>


                    </div>
                </div>
            )}
        </Mutation>


    )

}

ProjectClientListItem.propTypes = {
    project_id: PropTypes.string.isRequired,
    client: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired
}

export default ProjectClientListItem